<template>
  <section data-test="freeformRequisiteContent">

    <AppBadge
      v-if="disabled && value.showInCatalog"
      class="mb-2"
    >Shown in catalog</AppBadge>
    <AppSwitch
      v-if="!disabled && isFieldVisible('showInCatalog')"
      :disabled="!isFieldEditable('showInCatalog')"
      :value="(value.showInCatalog === undefined)?showInCatalogDefaultValue:value.showInCatalog"
      :label="`Show in ${$localize('catalog')}`"
      @input="updateData('showInCatalog', $event)"
    />
    <template v-if="disabled">
      <div
        v-if="!value.value"
        class="text-center p-3 rounded-5 bg-light border text-muted"
      >No Requirements Free Form Text</div>
      <FormWysiwyg
        v-else
        :disabled="true"
        :value="value.value"
      />
    </template>
    <FormWysiwyg
      v-else
      :value="value.value"
      @input="updateData('value', $event)"
    />
  </section>
</template>

<script>
import FormWysiwyg from '@/components/Forms/FormWysiwyg'
import { userHasAnyAllowedRole } from '@shared/permissions/validators'
import { mapGetters } from 'vuex'
import FormMixin from '@/components/Forms/FormMixin'
import { SHOW_IN_CATALOG_DEFAULT_VALUE } from '@shared/constants/requisites'

export default {
  mixins: [ FormMixin ],
  components: {
    FormWysiwyg,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      localValue: {},
    }
  },
  setup (props, { root }) {

    const requisitesFreeformConfig = props?.config?.fields?.requisitesFreeform || {}
    const requirementFieldsConfiguration = requisitesFreeformConfig?.config?.fields || {}

    return {
      requirementFieldsConfiguration,
    }
  },
  computed: {
    ...mapGetters([ 'user' ]),
    showInCatalogDefaultValue () {
      if (!this.requirementFieldsConfiguration) return SHOW_IN_CATALOG_DEFAULT_VALUE

      const fieldConfig = this.requirementFieldsConfiguration['showInCatalog'] || {}

      if (!fieldConfig.config) { return SHOW_IN_CATALOG_DEFAULT_VALUE }

      return fieldConfig.config.defaultValue
    },
  },
  methods: {
    isFieldVisible (fieldKey) {
      if (!this.requirementFieldsConfiguration) return false

      const fieldConfig = (this.requirementFieldsConfiguration[fieldKey] || {})['rolesAllowedToSee']
      return userHasAnyAllowedRole(this.user, null, fieldConfig)
    },
    isFieldEditable (fieldKey) {
      if (!this.requirementFieldsConfiguration) return false

      const fieldConfig = (this.requirementFieldsConfiguration[fieldKey] || {})['rolesAllowedToEdit']
      return userHasAnyAllowedRole(this.user, null, fieldConfig)
    },
    updateData (key, val) {

      // Note -  For existing courses/ programs changing showInCatalog default value won't make any impact
      // So we should only update this value only when someone makes any changes to Free form requisites

      if (key !== 'showInCatalog' && this.localValue.showInCatalog === undefined) {
        this.$set(this.localValue, 'showInCatalog', this.value.showInCatalog !== undefined ? this.value.showInCatalog : this.showInCatalogDefaultValue)
      }

      this.$set(this.localValue, key, val)

      this.$emit('input', { ...this.value, ...this.localValue })
    },

  },

}
</script>
